/**
 * 문자열이 null,undefined 또는 Empty 인지 확인하는 함수.
 * @param   str     원본 문자열
 * @return  null or Empty or undefined = true
 */
export function isNullOrBlank(str: string | null | undefined): boolean {
  if (str === undefined || str === null || str.trim().length === 0) {
    return true;
  }
  return false;
}